import { IconButton } from "@ameelio/ui";
import MicNoneIcon from "@mui/icons-material/MicNone";
import MicOffOutlinedIcon from "@mui/icons-material/MicOffOutlined";
import VideocamOffOutlinedIcon from "@mui/icons-material/VideocamOffOutlined";
import VideocamOutlinedIcon from "@mui/icons-material/VideocamOutlined";
import { common } from "@mui/material/colors";
import { SystemStyleObject, Theme } from "@mui/system";
import { useTranslation } from "react-i18next";
import { lightPalette } from "../theme";

const offStyle: SystemStyleObject<Theme> = {
  "&:hover": {
    backgroundColor: lightPalette.primary.dark,
    color: common.white,
  },
};

export type Props = {
  muted: boolean;
  hidden: boolean;
  micDisabled?: boolean;
  micDisabledHelperText?: string;
  onToggleAudio: () => void;
  onToggleVideo?: () => void;
};

export default function MediaControls({
  muted,
  hidden,
  micDisabled,
  micDisabledHelperText,
  onToggleAudio,
  onToggleVideo,
}: Props) {
  const { t } = useTranslation();
  const micDisabledStyles = {
    backgroundColor: lightPalette.action.disabledBackground,
    color: lightPalette.action.disabled,
  };
  return (
    <>
      {micDisabled ? (
        <IconButton
          tooltip
          ariaLabel={micDisabledHelperText || t("Your microphone is disabled")}
          sx={{
            ...micDisabledStyles,
            "&:hover": micDisabledStyles,
          }}
        >
          <MicOffOutlinedIcon />
        </IconButton>
      ) : (
        <IconButton
          tooltip
          onClick={onToggleAudio}
          ariaLabel={muted ? t("Turn on microphone") : t("Mute microphone")}
          sx={{
            backgroundColor: muted ? lightPalette.primary.main : "auto",
            color: muted ? common.white : "auto",
            ...(muted ? offStyle : {}),
          }}
        >
          {muted ? <MicOffOutlinedIcon /> : <MicNoneIcon fontSize="medium" />}
        </IconButton>
      )}
      {onToggleVideo && (
        <IconButton
          tooltip
          onClick={onToggleVideo}
          ariaLabel={hidden ? t("Turn on camera") : t("Turn off camera")}
          sx={{
            backgroundColor: hidden ? lightPalette.primary.main : "auto",
            color: hidden ? common.white : "auto",
            ...(hidden ? offStyle : {}),
          }}
        >
          {hidden ? <VideocamOffOutlinedIcon /> : <VideocamOutlinedIcon />}
        </IconButton>
      )}
    </>
  );
}
